const titles = ['role', 'email', 'accepted', 'created_at'];

export { titles };


export const inactiveMembersKey = 'inactive';